import { isWhenCalledTrigger } from './isWhenCalledTrigger.js';

export const getWhenCalledPolicy = (workflow) => {
  const triggers = (workflow?.steps || []).filter(isWhenCalledTrigger);
  if (triggers.length > 1) {
    return { success: false, message: 'A workflow can have only one When called trigger.' };
  }

  const step = triggers[0];
  const value = step?.options?.allowConcurrentRuns;
  const allowConcurrentRuns = value === undefined ? false : value;
  if (typeof allowConcurrentRuns !== 'boolean') {
    return { success: false, message: 'Allow concurrent runs must be a boolean.' };
  }

  return { success: true, data: { step, allowConcurrentRuns } };
};
